import * as sonbp from "sonbp";
import * as ifbase from "../base";

// -----------------------------------------------
// スタンプ独自の操作
// -----------------------------------------------

/**
 * スタンプを配置する
 */
export function setStampImg(ifdto: ifbase.ifDto, itemType: string, stampIdx: string, file_key: string, file_id: string, img_size: { w: number, h: number }, callback: (resKey: string) => void): void {

	var resKey = "";
	var v = ifdto.bpView;

	ifbase.util.getResouseKey(ifdto, file_key).then((d: ifbase.ImageResourceModel) => {

		return new sonbp.type.promise((resolve, reject) => {

			try {

				let ratio = 1 / sonbp.util.c2d.getUnit4Px(sonbp.constant.unit.PT, v.initialize.desiredDpi);

				let layer = ifbase.util.getLayer(ifdto, ifbase.constants.LTYPE_STAMP);
				let layerAddr = { pageIdx: 0, layerIdx: layer.idx, parentId: "", parentIdxs: [] };
				// 実際の画像サイズは引数に従う
				let orgSize = [0, 0, img_size.w * ratio, img_size.h * ratio];

				//スタンプの配置
				let info = sonbp.tool.itemXobject.create(
					v,
					d.Subtype,
					d.ResourceKey,
					[
						sonbp.util.bp.i2u(d.Width, v._exp.docUnit, v._exp.userUnitValue),
						sonbp.util.bp.i2u(d.Height, v._exp.docUnit, v._exp.userUnitValue)
					],
					layerAddr,
					true,
					"",
					null,
					function (item: sonbp.object.xobjectItem) {

						item.info.vendor_property.ffpsc = {
							item_type: itemType,
							idx: stampIdx,
							file_id: file_id,
							org_rect: orgSize
						};

						let rect = item.rect;

						item.scale(orgSize[2] / rect.width, orgSize[3] / rect.height);
					}
				);

				if (info == null) {
					throw new Error("tool.itemXobject.create result is null.");
				}

				resKey = d.ResourceKey;

				resolve();
			}
			catch (e) {

				reject(e);
			}
		});

	}).then(() => {

		callback(resKey);
	}).catch(e => {

		ifdto.callbackError(e);
	});
}

/**
 * スタンプ画像を変更する
 * アイテムの前後関係維持するため、アイテム自体の置換えではなくsrcの差替えで対処する
 */
export function updateStampImg(ifdto: ifbase.ifDto, itemId: string, file_key: string, file_id: string, callback: (resKey: string) => void): void {

	var resKey = "";
	var v = ifdto.bpView;

	ifbase.util.getResouseKey(ifdto, file_key).then((d: ifbase.ImageResourceModel) => {

		let refInfo = sonbp.tool.item.getRefInfo(v, itemId);

		return v._om.itemChangeAsync([refInfo], (itemRefs) => {

			return new sonbp.type.promise((resolve, reject) => {

				try {
					let stamp = itemRefs[0].item as sonbp.object.xobjectItem;

					stamp.src = d.ResourceKey;
					//stamp.subtype = d.Subtype;
					//stamp.size = [
					//	sonbp.util.bp.i2u(d.Width, v._exp.docUnit, v._exp.userUnitValue),
					//	sonbp.util.bp.i2u(d.Height, v._exp.docUnit, v._exp.userUnitValue)
					//];

					//画像差替えのみのため位置角度拡大はキープ

					//合成用の画像IDも差替え
					let vp = stamp.info.vendor_property.ffpsc;
					vp.file_id = file_id;

					resKey = d.ResourceKey;

					resolve();
				}
				catch (e) {

					reject(e);
				}
			});
		});

	}).then(() => {

		callback(resKey);
	}).catch(e => {

		ifdto.callbackError(e);
	});
}
